import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'Called when a user is in the depleted state and tries to take a blocked action',
  name: 'depleted_action_blocked',
  params: [
    {
      description: 'The action that was blocked',
      name: 'action',
      required: true,
      type: 'enum',
      values: ['upload', 'import', 'canvas_edit'],
    },
    {
      description: 'Number of days since the billing cycle started',
      name: 'days_since_cycle_start',
      required: true,
      type: 'number',
    },
  ],
};

export default META;
